import React, { useEffect, useState } from "react";
import { CommonButton } from "./CommonButton";
import PinPlacementImage from "assets/svgIcons/PinsSideNav/PinPlacementIcon";
import RotationSetupImage from "assets/svgIcons/PinsSideNav/PinRotationIcon";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { CommonHeading } from "./CommonHeading";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import { SubSideNavTabs } from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { useTranslation } from "react-i18next";

export const PinsSideNav = () => {
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { t } = useTranslation();
  const [ezLocatorState, setEzLocatorState] = useState(false);
  const { siteSettingsData, getUserRole, greensWithPinPlacementStateData } =
    useSelector((state) => state.commonReducers) || [];
  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName == "Pin Placement" ||
      getSubnavName === "Rotation Setup"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Pin Placement");
      localStorage.setItem("mapSideNavTabState", "Pin Placement");
    }
  }, []);

  useEffect(() => {
    if (
      greensWithPinPlacementStateData &&
      greensWithPinPlacementStateData.EzLocatorCourse
    ) {
      setEzLocatorState(true);
    } else {
      setEzLocatorState(false);
    }
  }, [greensWithPinPlacementStateData]);

  return (
    <div>
      <CommonHeading labelText={"Pins"} />
      <SubSideNavTabs>
        <Tooltip title={t("Pin_Placement")} arrow>
          <span>
            <CommonButton
              labelText={"Pin Placement"}
              displayText={"Pin_Placement"}
              changeSideNavData={() => {
                localStorage.setItem("mapSideNavTabState", "Pin Placement");
                mapSideNavTabState.set("Pin Placement");
              }}
              disabled={
                getFeatureSetOption(
                  siteSettingsData && siteSettingsData?.Features,
                  getFeaturesList().golfer_experience
                ) &&
                getUserRole &&
                getUserRole.Role != 6
              }
            >
              <PinPlacementImage
                color={
                  mapSideNavTabState.get() == "Pin Placement"
                    ? "var(--theme-text)"
                    : "var(--text-secondary)"
                }
              />
            </CommonButton>
          </span>
        </Tooltip>

        <Tooltip
          title={t("Rotation_Setup")}
          arrow
          style={{ display: ezLocatorState ? "none" : "block" }}
        >
          <span>
            <CommonButton
              labelText={"Rotation Setup"}
              displayText={"Rotation_Setup"}
              changeSideNavData={() => {
                localStorage.setItem("mapSideNavTabState", "Rotation Setup");
                mapSideNavTabState.set("Rotation Setup");
              }}
            >
              <RotationSetupImage
                color={
                  mapSideNavTabState.get() == "Rotation Setup"
                    ? "var(--theme-text)"
                    : "var(--text-secondary)"
                }
              />
            </CommonButton>
          </span>
        </Tooltip>
      </SubSideNavTabs>
    </div>
  );
};
